import type { FunctionComponent } from 'react';
import Comment from '@spraypaint/Comment';
import { CloseIcon } from '@/app/assets/icons/buttons';
import {
  CustomModal,
  CustomModalProps,
} from '@/modules/common/components/fragments/CustomModal';
import { Button } from '@/modules/common/components/buttons';
import { CommentFormValue, CommentList } from './CommentList';

type CommentsModalProps = {
  modalProps: CustomModalProps;
  comments?: Array<Comment>;
  onSubmit: (data: CommentFormValue) => void;
  isSubmitting: boolean;
  isSuccess: boolean;
  title?: string;
};

export const CommentsModal: FunctionComponent<CommentsModalProps> = ({
  modalProps,
  comments,
  onSubmit,
  isSubmitting,
  isSuccess,
  title = 'Commentaires',
}) => {
  const handleClose = modalProps.onRequestClose ?? (() => {});

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <CustomModal {...modalProps}>
        <div className="flex flex-row w-[900px] bg-color-light-grey py-[20px]">
          <div className="flex-auto ml-[25px] text-xl2">{title}</div>
          <Button
            onClick={handleClose}
            custom
            className="mr-[25px] justify-self-end"
          >
            <CloseIcon />
          </Button>
        </div>
        <div className="p-5">
          <CommentList
            comments={comments}
            onSubmit={onSubmit}
            isLoading={isSubmitting}
            isSuccess={isSuccess}
          />
        </div>
      </CustomModal>
    </div>
  );
};
